import React, { useEffect, useRef, useState } from 'react'

import ContactMe from '@nexys/components/ContactMe/ContactMe'
import Gap from '@nexys/components/Gap'
import Footer from 'layouts/containers/Public/Footer'
import Header from 'layouts/containers/Public/Header'
import { ReactComponentLike } from 'prop-types'

interface IProps {
  Component: ReactComponentLike
  pageProps: any
}

function PublicContainer(props: IProps) {
  const { Component, pageProps } = props
  const refHeader = useRef<HTMLElement>()
  const refFooter = useRef<HTMLElement>()
  const [heightHeaderFooter, setHeightHeaderFooter] = useState(0)

  useEffect(() => {
    if (refFooter.current && refHeader.current) {
      const headerHeight = refHeader.current?.clientHeight
      const footerHeight = refFooter.current?.clientHeight
      setHeightHeaderFooter(headerHeight + footerHeight)
    }
  }, [Boolean(refHeader.current), Boolean(refFooter.current)])

  return (
    <div>
      <Header
        refContent={refHeader}
        styleContainer={{
          backgroundColor: 'white',
          position: 'fixed',
          width: '100%',
          zIndex: '50',
          height: '96px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.1)',
        }}
      />
      <Gap height="30px" />
      <div
        style={{
          minHeight: `calc(100vh - ${heightHeaderFooter}px)`,
        }}
      >
        <div style={{ height: '40px' }} />
        <Component {...pageProps} />
      </div>
      <ContactMe />
      <Footer />

      {/* <BackTop duration={50} /> */}
    </div>
  )
}

export default PublicContainer
